// Energy meter (single / three phase). Read-only â€” shows the latest values
// streamed over MQTT. Detailed historical charts require the metering data
// endpoint (kept for a later pass).

import React from 'react';
import { Box, Typography, Card, Grid } from '@mui/material';
import DeviceShell from '../../components/DeviceShell';
import { useDeviceStatus } from '../../../../core/mqtt/useDeviceStatus';

export default function PhaseScreen({ device, phases, initialStatus = '' }) {
  const uno = device.UniqueNumber;
  const [status] = useDeviceStatus(uno, initialStatus);
  const parts = status ? status.split(',') : [];

  return (
    <DeviceShell title={device.DeviceName || uno}>
      <Typography color="text.primary" sx={{ mb: 2 }}>
        {phases === 3 ? 'Three-Phase' : 'Single-Phase'} Energy Meter
      </Typography>
      <Card sx={{ bgcolor: 'primary.main', p: 2, borderRadius: 3 }}>
        {parts.length ? (
          <Grid container spacing={2}>
            {parts.map((v, i) => (
              <Grid item xs={4} key={i}>
                <Typography variant="h5" color="primary.contrastText">{v}</Typography>
                <Typography variant="caption" sx={{ color: 'primary.contrastText', opacity: 0.7 }}>
                  field {i + 1}
                </Typography>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box sx={{ color: 'primary.contrastText', opacity: 0.8 }}>
            Waiting for live meter dataâ€¦
          </Box>
        )}
      </Card>
    </DeviceShell>
  );
}
